<template>
    <div>
        <b-card title="" border-variant="primary">
            <form-base-document-invigilando
                :documents-state-data="documents_maintenance_invigilando"
                :documents-columns="columns"
                :documents-route="documents_by_route_maintenance_invigilando"
                :context="'document-invigilando'"
                :create-permission="can('create_vhe_master_maintenance_invigilando')"
                :delete-permission="can('delete_vhe_master_maintenance_invigilando')"
            />
        </b-card>
    </div>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import {mapState} from "vuex"
import formBaseDocumentInvigilando
    from "@/views/vhe/masters_installations/form/tabMaintenance/components/base/formBaseInvigilando"

import {mapFields} from "vuex-map-fields"

export default {
    name: "FormContractProviderDocuments",
    components: {
        BCard,
        formBaseDocumentInvigilando
    },
    data() {
        return {
            columns: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'effective_date', label: 'Fecha Realización', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],
        }
    },
    computed: {
      ...mapState('masterInstallationVhe', ['master_installation']),
      ...mapState('masterInstallationDocumentsVhe', []),
        ...mapFields({
            documents_maintenance_invigilando: 'masterInstallationDocumentsVhe.documents_maintenance_invigilando',
            documents_by_route_maintenance_invigilando: 'masterInstallationDocumentsVhe.documents_by_route_maintenance_invigilando',
        }),
    },
    mounted() {
       this.context = 'document-invigilando'
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
    }

}
</script>